export default __webpack_public_path__ + "static/media/applications-image-12.d21c0aa6.jpg";